// パスワードリセット メールアドレス入力画面
import React, { useState } from 'react';
import './List.css';
import '../App.css';
import { Button, Snackbar, TextField } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import { mainBlueColor, btnColor } from '../GlobalState';
import { resetPassword } from '../apicalls/resetPassword';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import logo from '../assets/logo1.png';

export const ResetPassword: React.FC = () => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      },
      formControl: {
        minWidth: 120,
        backgroundColor: '#FFFFFF'
      },
      formControl1: {
        minWidth: 120,
        height: 30,
        borderRadius: 5,
        borderWidth: 1,
        paddingLeft: 5
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF'
      },
      input: {
        borderColor: '#c1c1c1',
        borderWidth: 1,
        width: 400,
        marginTop: 25
      },
      table1: {}
    })
  );

  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const classes = useStyles();

  const resetYourPassword = () => {
    let val =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    if (email.trim() === '') {
      setErrorMessage('メールアドレスを入力してください。');
      setOpen(true);
    } else if (!val.test(email.trim())) {
      setErrorMessage('メールアドレスの形式が不正です。');
      setOpen(true);
    } else {
      resetPassword(email.trim()).then(data => {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            setEmail('');
            setErrorMessage(data.message);
            setOpenSuccess(true);
          }
        }
      });
    }
  };

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <div
        className={classes.container}
        style={{
          backgroundColor: buttonColor,
          padding: 15,
          minHeight: window.innerHeight - 30
        }}
      >
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
          <Alert onClose={handleClose} severity='error'>
            {errorMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openSuccess}
          autoHideDuration={4000}
          onClose={handleCloseSuccess}
        >
          <Alert onClose={handleCloseSuccess} severity='success'>
            {errorMessage}
          </Alert>
        </Snackbar>

        <div
          style={{
            width: 400,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          }}
          className='container'
        >
          <div>
            <img
              style={{ width: 100, height: 60, objectFit: 'contain' }}
              alt='logo'
              src={logo}
            />
          </div>
          <div style={{ fontSize: 14 }}>
            ログイン用メールアドレスに、パスワードリセットのリンクを送信します。
          </div>
          <div>
            <TextField
              className={classes.input}
              id='outlined-mail'
              label='メールアドレス'
              variant='outlined'
              value={email}
              onChange={text => {
                setEmail(text.target.value);
              }}
              inputProps={{
                maxLength: 50
              }}
            />
          </div>

          <Button
            onClick={() => {
              resetYourPassword();
            }}
            style={{ backgroundColor: mainColor, marginTop: 20, width: 400 }}
            variant='contained'
            color='primary'
          >
            送信
          </Button>
        </div>
      </div>
    </div>
  );
};
